export default __webpack_public_path__ + "empty-issues-add-md.fa9fe0c7.svg";